import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Closes overlays/drawers when the user navigates to a different page.
 * Records pathname when `isOpen` becomes true; only a later pathname change triggers close.
 */
export function useCloseOnRouteChange(isOpen: boolean, onClose: () => void): void {
  const { pathname } = useLocation();
  const openedAtPathRef = useRef<string | null>(null);

  useEffect(() => {
    if (isOpen) {
      if (openedAtPathRef.current === null) {
        openedAtPathRef.current = pathname;
        return;
      }
      if (openedAtPathRef.current !== pathname) {
        openedAtPathRef.current = null;
        onClose();
      }
      return;
    }
    openedAtPathRef.current = null;
  }, [isOpen, pathname, onClose]);
}
